:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.quick-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

@media screen and (min-width: 980px) {
  .quick-actions {
    justify-content: flex-start;
    gap: 24px;
  }
}

.quick-actions .bv__rating {
  margin-top: 16px;
}

:host(:not([dir="rtl"])) .quick-actions .bv__rating {
  margin-right: 0;
}

:host([dir="rtl"]) .quick-actions .bv__rating {
  margin-left: 0;
}

@media screen and (max-width: 979px) {
  .quick-actions--is-cta .favorite-btn,
.quick-actions--is-cta .compare-control {
    display: flex;
    margin-top: 10px;
  }
}

@media screen and (min-width: 980px) {
  .quick-actions--is-cta .favorite-btn,
.quick-actions--is-cta .compare-control {
    display: none;
  }
}

.quick-actions-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  min-height: 34px;
}

@media screen and (max-width: 979px) {
  .quick-actions-wrapper {
    justify-content: center;
    margin: auto;
    min-height: auto;
  }
}

.compare-control {
  color: #333333;
  line-height: 1.5rem;
  margin-top: 9px;
  min-height: 17px;
}

@media screen and (max-width: 979px) {
  .compare-control {
    margin-top: 5px;
    display: none;
  }
}

.favorite-btn {
  margin-top: 10px;
}

@media screen and (max-width: 979px) {
  .favorite-btn {
    display: none;
  }
}

pes-favorites-button {
  overflow: hidden;
  white-space: nowrap;
}

@media screen and (max-width: 979px) {
  .bazaar-voice-rating {
    width: 100%;
  }
}